// Versão: 1.00
// Data..: 2026-09-24
// Geração e download de CSV no cliente (sem backend). Usa ; como separador
// e BOM UTF-8 para o Excel reconhecer acentuação corretamente.

// Escapa um valor para CSV.
function escapeCell(value: unknown): string {
  const s = value === undefined || value === null ? '' : String(value);
  return /[",\n;]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

// Monta o conteúdo CSV a partir do cabeçalho e das linhas.
export function toCsv(header: string[], rows: (unknown[])[]): string {
  const lines = [header.map(escapeCell).join(';')];
  for (const row of rows) lines.push(row.map(escapeCell).join(';'));
  return '\uFEFF' + lines.join('\n');
}

// Dispara o download de um CSV no navegador.
export function downloadCsv(fileName: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
